import CONFIG from "../../config/config";
import { callAuthorizedGraphQLEndpoint } from "../../module/graphQL";

// Authorized pathfinder caller for the batched findNumberHouseholds query built in d2dUnits.
export const callPathfinderHouseholds = (query, variables) =>
  callAuthorizedGraphQLEndpoint(query, variables, CONFIG.PATHFINDER_API_BASE_URL);
